export default "__VITE_ASSET__f6d4ce5a__"